import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Security Cameras",
        price: 180,
        disprice: 150,
        stock: 10,
        content: "Enhance your security with our advanced security cameras. Designed for reliable surveillance and monitoring, our security cameras provide peace of mind for your home or business.",
        description: "Ensure the safety of your property with our high-quality security cameras. Our security systems provide reliable surveillance for homes, businesses, and other properties, helping you monitor activities and deter unauthorized access.",
        category: ["Home Security", "Hardware Features"],
        tags: ["Security", "Surveillance", "Safety"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "SecurityPro" },
            { id: 2, title: "Resolution", content: "1080p HD" },
            { id: 3, title: "Viewing Angle", content: "120 degrees" },
            { id: 4, title: "Usage", content: "Home, Business, Commercial" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Emily Clark",
                date: "Mar 10, 2024",
                rating: 4.5,
                content: "These security cameras have been a game-changer for my home security. I can monitor my property remotely and have peace of mind knowing it's protected."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Michael Adams",
                date: "Apr 02, 2024",
                rating: 5,
                content: "The installation process was smooth, and the picture quality is excellent. I highly recommend these security cameras for anyone looking to enhance their security."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Security Cameras",
        price: 180,
        disprice: 150,
        stock: 5,
        content: "Enhance your security with our advanced security cameras. Designed for reliable surveillance and monitoring, our security cameras provide peace of mind for your home or business.",
        description: "Ensure the safety of your property with our high-quality security cameras. Our security systems provide reliable surveillance for homes, businesses, and other properties, helping you monitor activities and deter unauthorized access.",
        category: ["Window Styles", "Modern Entrances"],
        tags: ["Windows", "Entry", "Safety"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "SecurityPro" },
            { id: 2, title: "Resolution", content: "1080p HD" },
            { id: 3, title: "Viewing Angle", content: "120 degrees" },
            { id: 4, title: "Usage", content: "Home, Business, Commercial" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Emily Clark",
                date: "Mar 10, 2024",
                rating: 4.5,
                content: "These security cameras have been a game-changer for my home security. I can monitor my property remotely and have peace of mind knowing it's protected."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Michael Adams",
                date: "Apr 02, 2024",
                rating: 5,
                content: "The installation process was smooth, and the picture quality is excellent. I highly recommend these security cameras for anyone looking to enhance their security."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Bay Windows",
        price: 450,
        disprice: 400,
        stock: 8,
        content: "Transform your space with our elegant bay windows. Designed to bring in natural light and create a cozy nook, these windows add both beauty and functionality to any room.",
        description: "Bay windows offer a unique architectural appeal, expanding your interior space while enhancing the exterior aesthetic. Perfect for living rooms, bedrooms, or reading corners, they bring in more daylight and panoramic outdoor views.",
        category: ["Window Styles", "Home Security"],
        tags: ["Windows", "Entry", "Safety"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Vinyl & Wood Composite" },
            { id: 2, title: "Glazing", content: "Double-Pane Insulated Glass" },
            { id: 3, title: "Energy Rating", content: "Energy Star Certified" },
            { id: 4, title: "Style", content: "Fixed Center with Flanking Casements" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Sophia Rivera",
                date: "Feb 15, 2024",
                rating: 4.7,
                content: "Our living room looks completely transformed! These bay windows let in so much light and created a perfect sitting area. Worth every penny."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Daniel Moore",
                date: "Mar 28, 2024",
                rating: 4.9,
                content: "Excellent build quality and beautiful finish. The team helped with measurements and installation, and now our front view is stunning."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Door Handles",
        price: 60,
        disprice: 40,
        stock: 0,
        content: "Upgrade your doors with our premium-quality door handles. Sleek, durable, and ergonomically designed to enhance both function and style.",
        description: "Crafted with precision from high-grade stainless steel and zinc alloys, our door handles are built to withstand daily use while elevating the aesthetics of your interior or exterior doors. Available in multiple finishes to match any decor.",
        category: ["Hardware Features", "Door Designs"],
        tags: ["Handles", "Doors", "Hardware"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Stainless Steel & Zinc Alloy" },
            { id: 2, title: "Finish Options", content: "Matte Black, Chrome, Satin Nickel" },
            { id: 3, title: "Installation", content: "Surface Mount with Standard Screws" },
            { id: 4, title: "Type", content: "Lever Handle with Lock Option" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Emily Watson",
                date: "Apr 9, 2024",
                rating: 4.8,
                content: "Solid and stylish handles! The matte black finish gave my interior doors a modern touch. Super easy to install."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Leo Mitchell",
                date: "May 2, 2024",
                rating: 4.6,
                content: "Very sturdy and well-made. I got the satin nickel ones and they look fantastic on our new doors. Would buy again!"
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "French Doors",
        price: 500,
        disprice: 450,
        stock: 10,
        content: "Bring timeless elegance and natural light into your home with our beautifully crafted French doors—perfect for patios, interiors, or garden views.",
        description: "Our French doors are designed with classic charm and modern energy efficiency. Built with double-pane glass and sturdy wood or composite frames, they enhance any room with light and sophistication while maintaining excellent insulation.",
        category: ["Door Designs", "Modern Entrances"],
        tags: ["Doors", "French", "Entry"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Solid Wood or Composite with Tempered Glass" },
            { id: 2, title: "Glass Type", content: "Double-Pane Low-E Glass" },
            { id: 3, title: "Finish Options", content: "White, Oak, Walnut, Custom Colors" },
            { id: 4, title: "Opening Style", content: "In-Swing / Out-Swing" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Grace Allen",
                date: "Feb 20, 2024",
                rating: 5.0,
                content: "Absolutely stunning! These French doors transformed our dining area. Excellent quality and insulation."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Michael Chen",
                date: "Mar 18, 2024",
                rating: 4.7,
                content: "Great craftsmanship and easy to install. They look beautiful and keep the room warm and quiet."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Entry Doors",
        price: 490,
        disprice: 450,
        stock: 8,
        content: "Secure your home with style using our premium entry doors—crafted for durability, energy efficiency, and curb appeal.",
        description: "Our entry doors are built to offer the perfect balance of safety and style. Featuring reinforced cores, weatherproof seals, and customizable designs, they provide a warm welcome while protecting your home from the elements.",
        category: ["Modern Entrances", "Door Designs"],
        tags: ["Doors", "Entry", "Safety"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Steel, Fiberglass, or Solid Wood" },
            { id: 2, title: "Security Features", content: "Multi-point Locking System" },
            { id: 3, title: "Finish Options", content: "Textured, Painted, or Woodgrain Finish" },
            { id: 4, title: "Weather Resistance", content: "Foam Core Insulation with Weatherstripping" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Lena Watson",
                date: "Apr 3, 2024",
                rating: 4.9,
                content: "This entry door is solid, stylish, and keeps out the draft. The installation was quick and smooth!"
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Jared Monroe",
                date: "Apr 25, 2024",
                rating: 4.8,
                content: "Love the modern look and added security. It gave our home an instant upgrade."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Knobs and Pulls",
        price: 60,
        disprice: 45,
        stock: 12,
        content: "Add the finishing touch to your doors and cabinets with our stylish knobs and pulls, blending form and function seamlessly.",
        description: "From sleek modern designs to timeless classics, our knobs and pulls collection offers an array of finishes and shapes to complement any interior style. Easy to install and built for lasting performance, these accents elevate the look and feel of any space.",
        category: ["Hardware Features", "Home Security"],
        tags: ["Handles", "Hardware", "Safety"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Zinc Alloy, Stainless Steel, Brass" },
            { id: 2, title: "Finish Options", content: "Matte Black, Brushed Nickel, Antique Bronze" },
            { id: 3, title: "Installation", content: "Screws Included, Easy to Install" },
            { id: 4, title: "Size Variety", content: "Available in Multiple Lengths and Shapes" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Sophie Lang",
                date: "Feb 14, 2024",
                rating: 4.7,
                content: "Elegant and sturdy! These knobs added a premium look to my kitchen cabinets."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Carlos Rivera",
                date: "Mar 2, 2024",
                rating: 4.6,
                content: "Very pleased with the quality. Easy to install and feels solid in hand."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Security Bars",
        price: 160,
        disprice: 125,
        stock: 0,
        content: "Enhance your home’s protection with our robust and stylish security bars, designed for peace of mind without compromising aesthetics.",
        description: "Our security bars are engineered from heavy-duty steel to provide maximum protection while maintaining a clean, modern appearance. Whether for windows or doors, they are powder-coated for durability and come with tamper-resistant hardware for added safety.",
        category: ["Home Security", "Hardware Features"],
        tags: ["Security", "Safety", "Windows"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Reinforced Steel with Powder-Coated Finish" },
            { id: 2, title: "Installation", content: "Surface Mount or Recess Mount Options" },
            { id: 3, title: "Customization", content: "Custom Sizes and Designs Available" },
            { id: 4, title: "Security Feature", content: "Tamper-Resistant Screws and Locking Mechanism" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Angela Thomas",
                date: "Apr 12, 2024",
                rating: 4.8,
                content: "Super secure and looks better than I expected. Installation was straightforward."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Derek Kim",
                date: "May 1, 2024",
                rating: 4.5,
                content: "Great product for added security. I had them custom-fitted for my basement windows."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Sliding Patio Doors",
        price: 500,
        disprice: 420,
        stock: 5,
        content: "Upgrade your space with sleek, space-saving sliding patio doors that bring the outdoors in while enhancing energy efficiency.",
        description: "Our sliding patio doors feature smooth-glide tracks, dual-pane glass for insulation, and secure locking mechanisms. Perfect for maximizing natural light and offering seamless access to outdoor areas, they combine functionality with contemporary design.",
        category: ["Door Designs", "Modern Entrances"],
        tags: ["Doors", "Patio", "Entry"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Glass Type", content: "Double-Pane Tempered Glass" },
            { id: 2, title: "Frame Material", content: "Vinyl-Clad Aluminum" },
            { id: 3, title: "Track System", content: "Low-Friction Glide Technology" },
            { id: 4, title: "Security", content: "Multi-Point Locking System" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Hannah Wells",
                date: "Mar 22, 2024",
                rating: 4.7,
                content: "Beautiful and smooth sliding mechanism. Made a big difference in our living room."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Jason Brooks",
                date: "Apr 14, 2024",
                rating: 4.6,
                content: "High quality and easy to install. The glass keeps the room bright and well-insulated."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Surveillance Equipment",
        price: 480,
        disprice: 390,
        stock: 18,
        content: "Secure your property with advanced surveillance equipment offering high-resolution video, night vision, and real-time alerts.",
        description: "Our surveillance equipment includes HD cameras, motion sensors, and cloud storage options. Designed for both residential and commercial properties, it provides 24/7 monitoring, easy mobile access, and reliable security coverage you can trust.",
        category: ["Home Security", "Hardware Features"],
        tags: ["Security", "Surveillance", "Safety"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Camera Resolution", content: "1080p Full HD" },
            { id: 2, title: "Night Vision", content: "Up to 100 ft Infrared Range" },
            { id: 3, title: "Storage", content: "Cloud & Local DVR Options" },
            { id: 4, title: "Remote Access", content: "Compatible with iOS & Android" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Karen Steele",
                date: "May 2, 2024",
                rating: 4.8,
                content: "Crystal-clear footage and easy app setup. Great for peace of mind!"
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Leo Martinez",
                date: "May 6, 2024",
                rating: 4.7,
                content: "Reliable and sharp video even at night. Highly recommend for home security."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Swing Windows",
        price: 270,
        disprice: 220,
        stock: 25,
        content: "Enhance your home’s ventilation with stylish swing windows, offering easy access and superior airflow.",
        description: "Our swing windows are designed for both elegance and functionality. Perfect for homes that need a balance of aesthetics and efficiency, these windows provide wide openings, excellent ventilation, and a beautiful modern design.",
        category: ["Window Styles", "Hardware Features"],
        tags: ["Windows", "Entry", "Safety"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Quality Aluminum" },
            { id: 2, title: "Frame Color", content: "Customizable" },
            { id: 3, title: "Opening Mechanism", content: "Swing-Out" },
            { id: 4, title: "Glass Type", content: "Double Glazed" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Alice Thompson",
                date: "Mar 10, 2024",
                rating: 5,
                content: "These swing windows were easy to install and make a noticeable difference in air circulation."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "David Brooks",
                date: "Mar 15, 2024",
                rating: 4.5,
                content: "Great for airflow but could have been a bit sturdier. Overall, very happy with the purchase."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Angled Windows",
        price: 350,
        disprice: 300,
        stock: 18,
        content: "Add a unique touch to your home with angled windows, designed for exceptional style and energy efficiency.",
        description: "Our angled windows combine beauty and performance, offering a distinctive design that fits perfectly in modern homes. Designed to enhance your home’s curb appeal, they provide excellent natural light while helping reduce energy consumption.",
        category: ["Window Styles", "Modern Entrances"],
        tags: ["Windows", "Safety", "Entry"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Premium Vinyl" },
            { id: 2, title: "Frame Color", content: "White, Black, Custom Colors" },
            { id: 3, title: "Glass Type", content: "Triple Glazed" },
            { id: 4, title: "Energy Efficiency", content: "A++ Rated" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Sophia Green",
                date: "Apr 02, 2024",
                rating: 5,
                content: "These angled windows transformed the look of my living room. They let in so much light and are incredibly energy-efficient."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Ethan Clark",
                date: "Apr 10, 2024",
                rating: 4.5,
                content: "Stunning windows with great quality. The only downside is that installation took longer than expected."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Handle Hardware",
        price: 25,
        disprice: 20,
        stock: 50,
        content: "Elevate the functionality and aesthetics of your doors and windows with high-quality handle hardware.",
        description: "Our handle hardware offers a perfect combination of durability and style. Designed for a variety of doors and windows, these handles provide ease of use while adding a touch of elegance to any home. Available in a range of finishes to match your design preferences.",
        category: ["Hardware Features", "Door Designs"],
        tags: ["Handles", "Hardware", "Doors"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Brass, Stainless Steel, Zinc" },
            { id: 2, title: "Finish Options", content: "Matte, Polished, Antique" },
            { id: 3, title: "Compatibility", content: "Doors, Windows" },
            { id: 4, title: "Warranty", content: "5 Years" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Olivia Brown",
                date: "Apr 14, 2024",
                rating: 5,
                content: "These handles are so sturdy and add a refined look to my entry door. Highly recommend!"
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Lucas Wilson",
                date: "Apr 20, 2024",
                rating: 4.5,
                content: "Excellent quality handles. The only reason I didn’t give 5 stars is because I wish there were more color options."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Double Doors",
        price: 400,
        disprice: 350,
        stock: 20,
        content: "Add elegance and functionality to your home with our stylish double doors. Perfect for entryways and large openings.",
        description: "Our double doors are designed to provide a grand entrance with maximum durability and aesthetic appeal. Made from high-quality materials, these doors are available in various finishes to suit your home’s style. The perfect blend of beauty and security.",
        category: ["Door Designs", "Modern Entrances"],
        tags: ["Doors", "Entry", "Safety"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Wood, Fiberglass, Steel" },
            { id: 2, title: "Size Options", content: "36x80, 48x80, Custom Sizes" },
            { id: 3, title: "Finish Options", content: "Stained, Painted, Varnished" },
            { id: 4, title: "Warranty", content: "10 Years" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Sophia Davis",
                date: "Apr 18, 2024",
                rating: 5,
                content: "These double doors make my entrance look amazing! The quality is fantastic, and the installation was seamless."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Liam Harris",
                date: "Apr 22, 2024",
                rating: 4.5,
                content: "Beautiful doors with great craftsmanship. The only thing I wish for is more color choices."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Front Doors",
        price: 300,
        disprice: 250,
        stock: 15,
        content: "Transform the entrance of your home with our premium front doors, designed to enhance both style and security.",
        description: "Our front doors combine aesthetics with security, offering a variety of materials and styles to fit your home. These durable doors are designed to withstand the elements while providing a welcoming, stylish entrance. Choose from different finishes and features to suit your needs.",
        category: ["Modern Entrances", "Home Security"],
        tags: ["Doors", "Entry", "Safety"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Solid Wood, Steel, Fiberglass" },
            { id: 2, title: "Security Features", content: "Reinforced Frames, Advanced Locking Systems" },
            { id: 3, title: "Finish Options", content: "Painted, Stained, Natural Wood" },
            { id: 4, title: "Warranty", content: "Lifetime Warranty" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Oliver Scott",
                date: "Mar 30, 2024",
                rating: 5,
                content: "This front door is absolutely stunning. It makes my house feel more secure and elegant."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Emma Williams",
                date: "Apr 02, 2024",
                rating: 4.8,
                content: "I love the look of the door, and the installation was quick. It feels solid and secure."
            }
        ]
    },
];

export default products;